//Module Imports
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { FlashMessagesModule } from 'angular2-flash-messages';
import { UiSwitchModule } from 'ngx-toggle-switch/src';

//Component Imports
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { HomeSidebarComponent } from './components/home/home-sidebar/home-sidebar.component';
import { HomeWelcomeComponent } from './components/home/home-welcome/home-welcome.component';
import { HomeGalleryComponent } from './components/home/home-gallery/home-gallery.component';
import { HomeCommentsComponent } from './components/home/home-comments/home-comments.component';
import { ProductsComponent } from './components/products/products.component';
import { ProductsSidebarComponent } from './components/products/products-sidebar/products-sidebar.component';
import { ProductListComponent } from './components/products/product-list/product-list.component';
import { ProductDetailComponent } from './components/products/product-detail/product-detail.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { FooterComponent } from './components/footer/footer.component';
import { ProductCardComponent } from './components/products/product-card/product-card.component';
import { AccountComponent } from './components/account/account.component';
import { RegisterComponent } from './components/account/register/register.component';
import { ProfileEditComponent } from './components/account/profile-edit/profile-edit.component';
import { OrdersComponent } from './components/account/orders/orders.component';
import { TrackOrderComponent } from './components/account/track-order/track-order.component';
import { OrderDetailComponent } from './components/account/order-detail/order-detail.component';
import { AdminComponent } from './components/admin/admin.component';
import { AdminSidebarComponent } from './components/admin/admin-sidebar/admin-sidebar.component';
import { UserListComponent } from './components/admin/admin-customers/user-list/user-list.component';
import { UserEditComponent } from './components/admin/admin-customers/user-edit/user-edit.component';
import { ProductCardEditComponent } from './components/products/product-card/product-card-edit/product-card-edit.component';
import { ProductDetailEditComponent } from './components/products/product-detail/product-detail-edit/product-detail-edit.component';
import { NavSigninComponent } from './components/navbar/nav-signin/nav-signin.component';
import { AdminProductsComponent } from './components/admin/admin-products/admin-products.component';
import { AdminCustomersComponent } from './components/admin/admin-customers/admin-customers.component';
import { AdminProductListComponent } from './components/admin/admin-products/admin-product-list/admin-product-list.component';
import { AdminDashboardComponent } from './components/admin/admin-dashboard/admin-dashboard.component';
import { AdminProductEditComponent } from './components/admin/admin-products/admin-product-edit/admin-product-edit.component';
import { AdminProductAddComponent } from './components/admin/admin-products/admin-product-add/admin-product-add.component';
import { ApeSkuComponent } from './components/admin/admin-products/admin-product-edit/ape-sku/ape-sku.component';
import { ApeTitleComponent } from './components/admin/admin-products/admin-product-edit/ape-title/ape-title.component';
import { ApeActiveComponent } from './components/admin/admin-products/admin-product-edit/ape-active/ape-active.component';
import { ApeCategoryComponent } from './components/admin/admin-products/admin-product-edit/ape-category/ape-category.component';
import { ApeSubtitleComponent } from './components/admin/admin-products/admin-product-edit/ape-subtitle/ape-subtitle.component';
import { ApeImageSummaryComponent } from './components/admin/admin-products/admin-product-edit/ape-image-summary/ape-image-summary.component';
import { ApeImageDetailComponent } from './components/admin/admin-products/admin-product-edit/ape-image-detail/ape-image-detail.component';
import { ApeSummaryComponent } from './components/admin/admin-products/admin-product-edit/ape-summary/ape-summary.component';
import { ApeDescriptionComponent } from './components/admin/admin-products/admin-product-edit/ape-description/ape-description.component';
import { ApeUnitInfoComponent } from './components/admin/admin-products/admin-product-edit/ape-unit-info/ape-unit-info.component';
import { ApePriceComponent } from './components/admin/admin-products/admin-product-edit/ape-price/ape-price.component';
import { ApePaypalCodeComponent } from './components/admin/admin-products/admin-product-edit/ape-paypal-code/ape-paypal-code.component';


//Service Imports
import { AuthService } from './services/auth.service';
import { AuthGuard } from './guards/auth.guard';
import { UserService } from './services/user.service';
import { ProductService } from './services/product.service';
import { ValidateService } from './services/validate.service';
import { BootstrapRelayService } from './services/bootstrap-relay.service';
import { FlashService } from './services/utility/flash.service';
import { HtmlHelperService } from './services/utility/html-helper.service';
import { ProductValidatorService } from './services/validators/product-validator.service';
import { HttpHelperService } from './services/utility/http-helper.service';

//Routes
const appRoutes: Routes = [
  {path: '', component: HomeComponent},
  {path: 'products', component: ProductsComponent},
  {path: 'products/:category', component: ProductsComponent},
  {path: 'products/:category/:sku', component: ProductsComponent},
  {path: 'products/edit/card/:sku', component: ProductsComponent},
  {path: 'products/edit/detail/:sku', component: ProductsComponent},
  {path: 'admin', component: AdminComponent, canActivate:[AuthGuard]},
  {path: 'admin/:category', component: AdminComponent, canActivate:[AuthGuard]},
  {path: 'admin/:category/edit/:sku', component: AdminComponent, canActivate:[AuthGuard]},
  {path: 'admin/:category/add', component: AdminComponent, canActivate:[AuthGuard]},
  {path: 'admin/customers', component: AdminComponent, canActivate:[AuthGuard]},
  {path: 'account', component: AccountComponent, canActivate:[AuthGuard]},
  {path: 'account/profile', component: AccountComponent, canActivate:[AuthGuard]},
  {path: 'account/orders', component: AccountComponent, canActivate:[AuthGuard]},
  {path: 'account/reviews', component: AccountComponent, canActivate:[AuthGuard]},
  {path: 'trackorder', component: TrackOrderComponent},
  {path: '**', component: PageNotFoundComponent}
]


//Decorators for angular
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HomeSidebarComponent,
    HomeWelcomeComponent,
    HomeGalleryComponent,
    HomeCommentsComponent,
    ProductsComponent,
    ProductsSidebarComponent,
    ProductListComponent,
    ProductDetailComponent,
    NavbarComponent,
    PageNotFoundComponent,
    FooterComponent,
    ProductCardComponent,
    AccountComponent,
    RegisterComponent,
    ProfileEditComponent,
    OrdersComponent,
    TrackOrderComponent,
    OrderDetailComponent,
    AdminComponent,
    AdminSidebarComponent,
    UserListComponent,
    UserEditComponent,
    ProductCardEditComponent,
    ProductDetailEditComponent,
    NavSigninComponent,
    AdminProductsComponent,
    AdminCustomersComponent,
    AdminDashboardComponent,
    AdminProductListComponent,
    AdminProductEditComponent,
    ApeSkuComponent,
    ApeTitleComponent,
    ApeActiveComponent,
    ApeCategoryComponent,
    ApeSubtitleComponent,
    ApeImageSummaryComponent,
    ApeImageDetailComponent,
    ApeSummaryComponent,
    ApeDescriptionComponent,
    ApeUnitInfoComponent,
    ApePriceComponent,
    ApePaypalCodeComponent,
    AdminProductAddComponent,
  ],
  imports: [
    RouterModule.forRoot(appRoutes),
    BrowserModule,
    HttpModule,
    FormsModule,
    FlashMessagesModule,
    UiSwitchModule
  ],
  providers: [
    AuthService,
    AuthGuard,
    UserService,
    ProductService,
    ValidateService,
    BootstrapRelayService,
    FlashService,
    HtmlHelperService,
    ProductValidatorService,
    HttpHelperService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }


//Unused Code
// {path: 'admin/:admincategory/card/edit/:sku', component: ProductsComponent},


// WEBPACK FOOTER //
// ./src/app/app.module.ts